import Vue from 'vue'
// import '@/styles/var.less'
import '@/styles/index.css'
import '@/styles/mystyle.css'
import App from './App.vue'
import store from './store'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import i18n from '@/lang'
import './assets/iconfont/iconfont.css'
import { Row, Col, Cell, CellGroup } from 'vant'
import globalVariable from '@/api/global_variable.js'

// Vue.prototype.GLOBAL = globalVariable
Vue.config.productionTip = false
Vue.use(Row).use(Col).use(Cell).use(CellGroup).use(BaiduMap, {
  ak: 'Bl9YCmOqOGowxVrKT1yGxPa4HMteF4Wa'
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


router.afterEach((to, from) => { 
  console.log("router.afterEach")
  console.log("from",to)
  console.log("to",to)
  console.log("url",to.fullPath)
  console.log("IosStartURL",globalVariable.IosStartURL)
  if(!globalVariable.IosStartURL)
  {
    globalVariable.IosStartURL = to.fullPath.split('#')[0]
  }
  console.log("IosStartURL2",globalVariable.IosStartURL)
})